<template>
<div class="audio-media">
    <PageBreadcrumb :pagetitle="info.title"/>
    <!-- News -->
    <section class="newssec py-5">
        <div class="container">
            <div id="app-instasearch">
                <div class="input-container form-group">
                    <input type="text" class="form-control" placeholder="Type a name" v-model="authorNameSearchString" />
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-9 mb-5 mb-lg-0">
                    <div class="row">
                                <div v-for="mediaaudio in filteredPhotoFeed" :key="mediaaudio.nid" class="col-12 col-md-6 col-lg-4 mb-4">
                                    <div class="news-block text-center position-relative">
                                        <div class="news-image shrink-effect position-relative gradient-bt">
                                            <div class="ready-player-2">
                                                <audio>
                                                    <source :src="handleBase() + mediaaudio.field_audio_upload" type="audio/mpeg">
                                                </audio>
                                            </div>
                                            <div class="news-author text-white bg-primary text-white">
                                                <i class="fa fa-user-o"></i> by <b class="text-white">{{ mediaaudio.field_audio_teacher }}</b> <br />
                                                <span><i class="fa fa-calendar"></i>{{ mediaaudio.revision_timestamp }}</span>
                                            </div>
                                        </div>
                                        <div class="news-content">
                                            <div class="author-txt align-self-center">
                                            <span>
                                                <b class="text-danger author-title">{{ mediaaudio.title }}</b>
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    </div>
                </div>
                <div class="col-12 col-lg-3">
                    <!-- Start SideBarExtras -->
                    <SideBarExtras />
                    <hr>
                    <!-- Start Latest News Sidebar -->
                    <LatestNews />
                    <!-- End Latest News Sidebar -->
                </div>
            </div>
        </div>
    </section>
    <!-- End News -->
</div>
</template>

<script>
import axios from 'axios';
import LatestNews from "../components/LatestNews";
import PageBreadcrumb from "../components/PageBreadcrumb";
import SideBarExtras from "../components/SideBarExtras";
import GreenAudioPlayer from "../assets/js/green-audio-player";

export default{
    name: 'Egea Media',
    data () {
        return {
            info: { title : "Search and listen to audios" },
            mediaaudios: [],
            search: '',
            searchedString: "",
            audioFeed: null,
            authorNameSearchString: "",
            photoFeed: null
        }
    },
    components:{
        PageBreadcrumb, LatestNews, SideBarExtras
    },

    mounted() {
        axios
            .get('https://api.fifmi.org.au/api/media-audio')
            .then(result => {
                for (var i = 0; i < result.data.length; i++) {
                    if(result.data[i].field_domain_access.includes('fifmi')){
                        this.mediaaudios.push(result.data[i])
                    }
                }
            })
            .catch(error => console.log(error))
    },
    computed: {

        filteredPhotoFeed: function () {

            let audios = this.mediaaudios;
            const authorNameSearchString = this.authorNameSearchString;

            if(!authorNameSearchString){
                return audios;
            }

            // eslint-disable-next-line no-undef
            // let searchString = authorNameSearchString.trim().toLowerCase();

            audios = audios.filter(function(item){
                if(item.title.toLowerCase().indexOf(authorNameSearchString) !== -1){
                    return item;
                }
            })

            return audios;
        }
    },
    updated() {
        this.$nextTick(function () {
            GreenAudioPlayer.init({
                selector: '.ready-player-2',
                stopOthersOnPlay: true
            });
        });
    },
    methods: {
        handleBase: function () {
            return "https://www.fifmi.org.au"
        }
    }
}
</script>
